var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"norm-layout"},[_c('div',{staticClass:"norm-wrapper"},[_c('div',{staticClass:"norm-toolbar"},[_vm._t("toolbar")],2),_c('div',{staticClass:"norm-content"},[_c('div',{staticClass:"norm-tree"},[_vm._t("default")],2),_c('div',{staticClass:"norm-view"},[_vm._t("item")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }